import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=0105e0f2&scoped=true&"
import script from "./suppliers.vue?vue&type=script&lang=js&"
export * from "./suppliers.vue?vue&type=script&lang=js&"
import style0 from "./suppliers.vue?vue&type=style&index=0&id=0105e0f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0105e0f2",
  null
  
)

export default component.exports